import instance from '../../../api/axios'
import {
  AnalyzedBigPurchase,
  AnalyzedDailyPurchase,
  BigPurchase,
  CreateBigPurchase,
  CreateDailyPurchase,
  CreateUtilityBill,
  DailyPurchase,
  UpdateBigPurchase,
  UpdateDailyPurchase,
  UpdateUtilityBill,
  UtilityBill,
} from '../types/purchase'

export const loadDailyPurchases = async (): Promise<DailyPurchase[]> => {
  const response = await instance.get('/purchases/daily')
  return response.data
}

export const saveDailyPurchase = async (
  purchase: CreateDailyPurchase,
): Promise<DailyPurchase> => {
  const response = await instance.post('/purchases/daily', purchase)
  return response.data
}

export const modifyDailyPurchase = async (
  purchase: UpdateDailyPurchase,
): Promise<DailyPurchase> => {
  const response = await instance.put('/purchases/daily', purchase)
  return response.data
}

export const removeDailyPurchase = async (id: string): Promise<string> => {
  const response = await instance.delete(`/purchases/daily/${id}`)
  return response.data
}

export const updateDailyProductType = async (
  productId: string,
  productType: string,
  remember = true,
): Promise<void> => {
  await instance.put(`/purchases/daily/products/${productId}/type`, {
    productType,
    remember,
  })
}

export const classifyComparisonProduct = async (
  productId: string,
): Promise<{ baseProductName: string }> => {
  const response = await instance.post(
    `/purchases/comparison/products/${productId}/classify`,
  )
  return response.data
}

export const analyzeDailyReceipt = async (
  file: File,
): Promise<AnalyzedDailyPurchase> => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await instance.post(
    '/purchases/daily/analyze-receipt',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
  return response.data
}

export const loadBigPurchases = async (): Promise<BigPurchase[]> => {
  const response = await instance.get('/purchases/big')
  return response.data
}

export const saveBigPurchase = async (
  purchase: CreateBigPurchase,
): Promise<BigPurchase> => {
  const response = await instance.post('/purchases/big', purchase)
  return response.data
}

export const modifyBigPurchase = async (
  purchase: UpdateBigPurchase,
): Promise<BigPurchase> => {
  const response = await instance.put('/purchases/big', purchase)
  return response.data
}

export const removeBigPurchase = async (id: string): Promise<string> => {
  const response = await instance.delete(`/purchases/big/${id}`)
  return response.data
}

export const analyzeBigPurchaseImage = async (
  file: File,
): Promise<AnalyzedBigPurchase> => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await instance.post(
    '/purchases/big/analyze-image',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
  return response.data
}

export const loadUtilityBills = async (): Promise<UtilityBill[]> => {
  const response = await instance.get('/purchases/utilities')
  return response.data
}

export const saveUtilityBill = async (
  bill: CreateUtilityBill,
): Promise<UtilityBill> => {
  const response = await instance.post('/purchases/utilities', bill)
  return response.data
}

export const modifyUtilityBill = async (
  bill: UpdateUtilityBill,
): Promise<UtilityBill> => {
  const response = await instance.put('/purchases/utilities', bill)
  return response.data
}

export const removeUtilityBill = async (id: string): Promise<string> => {
  const response = await instance.delete(`/purchases/utilities/${id}`)
  return response.data
}
